export default function ResultListItemDetails({ title, subtitle }) {
    return (
        <div className="results-list-item__text results-list-item__details">
            <p className="results-list-item__title">{ title }</p>
            <p className="results-list-item__id">{ subtitle }</p>
        </div>
    )
}